export var getMobileFontSizeClassName = function (fontSize) {
    return "mf-" + fontSize;
};
//# sourceMappingURL=get-mobile-font-size-class-name.js.map